import React from "react";

function SankeyChart(props) {
    const { statuses, leftTotals, rightTotals, transitions, colorFn, labelFn, leftHead, rightHead } = props

    const leftStatuses = statuses.filter(status => leftTotals[status] !== undefined)
    const rightStatuses = statuses.filter(status => rightTotals[status] !== undefined)

    let totalCases = 0
    leftStatuses.forEach(status => {
        totalCases += leftTotals[status] || 0
    })
    totalCases = Math.max(1, totalCases)

    const chartWidth = 1160
    const chartHeight = 520
    const paddingTop = 20
    const paddingBottom = 16
    const nodeWidth = 18
    const nodeGap = 26
    const minNodeHeight = 8
    const labelColumnWidth = 280
    const leftNodeX = labelColumnWidth
    const rightNodeX = chartWidth - labelColumnWidth - nodeWidth
    const nodeCount = Math.max(leftStatuses.length, rightStatuses.length, 1)
    const caseScale = (chartHeight - paddingTop - paddingBottom - nodeGap * nodeCount) / totalCases

    let leftCursorY = paddingTop
    const leftNodes = {}
    leftStatuses.forEach(status => {
        const nodeHeight = Math.max((leftTotals[status] || 0) * caseScale, minNodeHeight)
        leftNodes[status] = { y: leftCursorY, height: nodeHeight, flowCursor: leftCursorY }
        leftCursorY += nodeHeight + nodeGap
    })

    let rightCursorY = paddingTop
    const rightNodes = {}
    rightStatuses.forEach(status => {
        const nodeHeight = Math.max((rightTotals[status] || 0) * caseScale, minNodeHeight)
        rightNodes[status] = { y: rightCursorY, height: nodeHeight, flowCursor: rightCursorY }
        rightCursorY += nodeHeight + nodeGap
    })

    const bands = []
    leftStatuses.forEach(sourceStatus => rightStatuses.forEach(targetStatus => {
        const transitionCount = (transitions[sourceStatus] || {})[targetStatus] || 0
        if (!transitionCount) return

        const bandThickness = transitionCount * caseScale
        const bandLeftTop = leftNodes[sourceStatus].flowCursor
        const bandLeftBottom = bandLeftTop + bandThickness
        const bandRightTop = rightNodes[targetStatus].flowCursor
        const bandRightBottom = bandRightTop + bandThickness
        leftNodes[sourceStatus].flowCursor = bandLeftBottom
        rightNodes[targetStatus].flowCursor = bandRightBottom

        const bandStartX = leftNodeX + nodeWidth
        const bandEndX = rightNodeX
        const bandMidX = (bandStartX + bandEndX) / 2
        const decisionChanged = sourceStatus !== targetStatus
        const bandPath = `M${bandStartX},${bandLeftTop.toFixed(1)} C${bandMidX},${bandLeftTop.toFixed(1)} ${bandMidX},${bandRightTop.toFixed(1)} ${bandEndX},${bandRightTop.toFixed(1)}`
            + ` L${bandEndX},${bandRightBottom.toFixed(1)} C${bandMidX},${bandRightBottom.toFixed(1)} ${bandMidX},${bandLeftBottom.toFixed(1)} ${bandStartX},${bandLeftBottom.toFixed(1)} Z`

        bands.push(
            <path
                key={sourceStatus + "_" + targetStatus}
                d={bandPath}
                fill={colorFn(targetStatus)}
                fillOpacity={decisionChanged ? 0.55 : 0.2}
                stroke={decisionChanged ? colorFn(targetStatus) : "none"}
                strokeWidth={decisionChanged ? 1 : 0}
            />
        )
    }))

    return (
        <svg viewBox={`0 0 ${chartWidth} ${chartHeight}`} width="100%" preserveAspectRatio="xMidYMid meet" style={{ display: "block", maxWidth: chartWidth, margin: "0 auto" }}>
            {bands}
            {leftStatuses.map(status => (
                <g key={"left_" + status}>
                    <rect x={leftNodeX} y={leftNodes[status].y} width={nodeWidth} height={leftNodes[status].height} rx="2" fill={colorFn(status)} />
                    <text x={leftNodeX - 8} y={leftNodes[status].y + leftNodes[status].height / 2 + 4} fontSize="12" textAnchor="end" fill="#333" fontFamily="Open Sans">
                        {labelFn(status)} {leftTotals[status]}
                    </text>
                </g>
            ))}
            {rightStatuses.map(status => (
                <g key={"right_" + status}>
                    <rect x={rightNodeX} y={rightNodes[status].y} width={nodeWidth} height={rightNodes[status].height} rx="2" fill={colorFn(status)} />
                    <text x={rightNodeX + nodeWidth + 8} y={rightNodes[status].y + rightNodes[status].height / 2 + 4} fontSize="12" textAnchor="start" fill="#333" fontFamily="Open Sans">
                        {labelFn(status)} {rightTotals[status]}
                    </text>
                </g>
            ))}
            <text x={leftNodeX + nodeWidth / 2} y="10" fontSize="11" textAnchor="middle" fill="#6f6f6f" fontFamily="Open Sans">{leftHead}</text>
            <text x={rightNodeX + nodeWidth / 2} y="10" fontSize="11" textAnchor="middle" fill="#6f6f6f" fontFamily="Open Sans">{rightHead}</text>
        </svg>
    )
}

export default SankeyChart
